import { GET_FUNDING_REPORT, GET_FUNDING_REPORT_FAIL, GET_FUNDING_REPORT_SUCCESS } from "./actionTypes";

export const getFundingReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_FUNDING_REPORT,
  payload: { data, onSuccess, onError },
});

export const getFundingReportSuccess = (data = {}) => ({
  type: GET_FUNDING_REPORT_SUCCESS,
  payload: data,
});

export const getFundingReportFail = (data = {}) => ({
  type: GET_FUNDING_REPORT_FAIL,
  payload: data,
});
